export function currencyFormat(value: number, prefix: string) {
    const isNumber = typeof value === 'number'

    if (!isNumber) value = 0

    let newValue = value.toFixed(2).replace('.',',')
    newValue = (prefix ? `${prefix}`: '') + newValue.replace(/\d(?=(\d{3})+\.)/g, '$&.')

    return newValue
}